import { useEffect, useState } from 'react'
import { useAuth } from './useAuth'
import type { AccountAccess } from '../lib/accountAccess'
import { isPlacesPreviewOnly } from '../lib/accountAccess'
import * as profilesApi from '../lib/api/profiles'

export function useAccountAccess(): {
  access: AccountAccess | null
  placesPreviewOnly: boolean
  loading: boolean
} {
  const { user } = useAuth()
  const [access, setAccess] = useState<AccountAccess | null>(null)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (!user?.id) {
      setAccess(null)
      setLoading(false)
      return
    }
    let cancelled = false
    setLoading(true)
    void (async () => {
      try {
        const p = await profilesApi.getMyProfile()
        if (cancelled) return
        const raw = p?.account_access
        setAccess(raw === 'places_preview' || raw === 'full' ? raw : 'full')
      } catch {
        if (!cancelled) setAccess('full')
      } finally {
        if (!cancelled) setLoading(false)
      }
    })()
    return () => {
      cancelled = true
    }
  }, [user?.id])

  return {
    access,
    placesPreviewOnly: isPlacesPreviewOnly(access),
    loading,
  }
}
